import { type ReactElement } from 'react'
import type { SerializedGemstone } from '../types'
import { getGroupUrl } from '@stuller/stullercom/util/core'
import { Button } from '@stuller/stullercom/ui'
import { isStringEmpty } from '@stuller/shared/util/core'

interface SimilarGemstonesButtonProps {
  /**
   * The serialized gemstone being viewed
   */
  serializedGemstone: SerializedGemstone
}

/**
 * Button to link to similar gemstones
 */
function SimilarGemstonesButton ({ serializedGemstone }: SimilarGemstonesButtonProps): ReactElement | null {
  // Check if the gemstone has a default product group
  if (serializedGemstone.defaultProductGroup?.code == null || serializedGemstone.defaultProductGroup?.id == null) {
    return null
  }

  const groupUrl = getGroupUrl(serializedGemstone.defaultProductGroup?.code, serializedGemstone.defaultProductGroup?.id)

  return (
    <div className='text-center'>
      <h3>Browse Similar Notable Gems&reg;{!isStringEmpty(serializedGemstone.stoneFamily) ? ` ${serializedGemstone.stoneFamily}` : ''}</h3>
      <Button tag='a' href={groupUrl} target='_blank'>Shop Now</Button>
    </div>
  )
}

export {
  SimilarGemstonesButton
}
